// create a container and set the full-size image as its background
function createOverlay(image) {
  const overlayImage = document.createElement('img');
  overlayImage.setAttribute('src', `${image.src}`);
  overlay = document.createElement('div');
  prepareOverlay(overlay, overlayImage);

  image.style.opacity = '50%';
  toggleLoadingSpinner(image);

  overlayImage.onload = () => {
    toggleLoadingSpinner(image);
    image.parentElement.insertBefore(overlay, image);
    image.style.opacity = '100%';
  };

  return overlay;
}

function prepareOverlay(container, image) {
  container.setAttribute('class', 'image-magnify-full-size');
  container.setAttribute('aria-hidden', 'true');
  container.style.backgroundImage = `url('${image.src}')`;
  container.style.backgroundColor = 'var(--gradient-background)';
}

function toggleLoadingSpinner(image) {
  const loadingSpinner = image.parentElement.parentElement.querySelector(`.loading__spinner`);
  loadingSpinner.classList.toggle('hidden');
}

function moveWithHover(image, event, zoomRatio) {
  // calculate mouse position
  const ratio = image.height / image.width;
  const container = event.target.getBoundingClientRect();
  const xPosition = event.clientX - container.left;
  const yPosition = event.clientY - container.top;
  const xPercent = `${xPosition / (image.clientWidth / 100)}%`;
  const yPercent = `${yPosition / ((image.clientWidth * ratio) / 100)}%`;

  // determine what to show in the frame
  overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
  overlay.style.backgroundSize = `${image.width * zoomRatio}px`;
}

function magnify(image, zoomRatio) {
  image.setAttribute('is-magnify', true);
  const overlay = createOverlay(image);
  overlay.onclick = () => {
    overlay.remove();
    setTimeout(() => {
      image.removeAttribute('is-magnify');
    }, 100);
  }
  overlay.onmousemove = (event) => moveWithHover(image, event, zoomRatio);
  overlay.onmouseleave = () => {
    overlay.remove();
    image.removeAttribute('is-magnify');
  }
}

function enableZoomOnHover(zoomRatio) {
  const images = document.querySelectorAll('.image-magnify-hover');
  images.forEach((image) => {
    image.onclick = (event) => {
      if (document.body.hasAttribute('pdp-thumbnails-ab-test') && window.innerWidth >= 750) return;
      magnify(image, zoomRatio);
      moveWithHover(image, event, zoomRatio);
    };
  });
  document.querySelectorAll('.product__modal-opener:has(>.product__media-icon-zoom)').forEach(element => {
    element.addEventListener('click', (event) => {
      if (
        !document.body.hasAttribute('pdp-thumbnails-ab-test') ||
        window.innerWidth < 750 ||
        event.target.classList.contains('.image-magnify-full-size')
      ) return;
      const image = element.querySelector('.product__media img');
      if (!image || image.hasAttribute('is-magnify')) return;
      magnify(image, zoomRatio);
      moveWithHover(image, event, zoomRatio);
    });
  });
}

enableZoomOnHover(2);
